import httpsV2 from '../../config/httpsV2'

export const getMfSilkRoadConfigurations = () => {
  return httpsV2.get('/silkroad/partner-silk-road-configuration')
}

export const getMfSilkRoadConfigurationById = (id) => {
  return httpsV2.get('/silkroad/partner-silk-road-configuration/' + id)
}

export const createMfSilkRoadConfiguration = (body) => {
  return httpsV2.post('/silkroad/partner-silk-road-configuration', body)
}

export const updateMfSilkRoadConfiguration = (id, body) => {
  return httpsV2.patch('/silkroad/partner-silk-road-configuration/' + id, body)
}

export const deleteMfSilkRoadConfiguration = (id) => {
  return httpsV2.delete('/silkroad/partner-silk-road-configuration/' + id)
}
export const deactivateMfSilkRoadConfiguration = (id) => {
  return httpsV2.delete('/silkroad/partner-silk-road-configuration/' + id)
}
